<template>
    <v-dialog v-model="getModalExcluirOrcamento" max-width="720px" transition="dialog-transition">
        <v-card>
            <v-card-title>Excluir</v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja excluir?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalExcluirOrcamento(false)" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="error" @click="excluirOrcamento(getOrcamento.id)" outlined>Sim</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getModalExcluirOrcamento',
                'getOrcamento',
            ])
        },
        methods: {
            ...mapActions([
                'setModalExcluirOrcamento',
                'excluirOrcamento',
            ])
        },
        
    }
</script>